import HomeOutlineEight from '@assets/icons/home-outline-eight.svg'
import { Icon } from './Icon'

export const HomeOutlineEightIcon = Icon(HomeOutlineEight)
